import uniqBy from 'lodash/uniqBy';
import {
  CONVERSATIONS_EMPLOYEE_BAN_UPDATE,
  CONVERSATIONS_EMPLOYEE_UNBAN,
  CONVERSATIONS_EMPLOYEE_BAN,
  CONVERSATIONS_ITEM_ACCEPT,
  CONVERSATIONS_ITEM_COMPLETE,
  CONVERSATIONS_ITEM_REJECT,
  CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE,
  FETCH_CONVERSATIONS_ERROR,
  FETCH_CONVERSATIONS_SUCCESS,
  CONVERSATIONS_UPDATE,
  CONVERSATIONS_DELETE,
  CONVERSATIONS_ITEM_SEEN,
  CONVERSATIONS_ITEM_NOT_SEEN,
} from '../actions/type';
import { DEAL_STATUS, STATUS_PERSON } from 'constants/chatConstants';

export default function conversations(state = { items: [] }, action) {
  switch (action.type) {
    case FETCH_CONVERSATIONS_SUCCESS:
      return {
        items: uniqBy([...state.items, ...action.payload.items], 'id'),
        error: null, // Очищаем ошибку при успешном ответе
      };
    case FETCH_CONVERSATIONS_ERROR:
      return { ...state, error: action.payload };
    case CONVERSATIONS_UPDATE:
      let conversations = [...state.items];
      const conversationItemIndex = conversations.findIndex((el) => el.id === action.payload.id);
      if (conversationItemIndex === -1) {
        conversations = [action.payload, ...conversations];
      } else {
        conversations = [action.payload, ...conversations.filter((el) => el.id !== action.payload.id)];
      }
      return { ...state, items: conversations };
    case CONVERSATIONS_DELETE:
      const newConversations = state.items.filter((el) => el.employee.id !== action.payload);
      return { items: newConversations };
    case CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE:
      return {
        items: state.items.map((el) => {
          if (el.employee.id === action.payload.contact_id) {
            el.employee.isContact = !el.employee.isContact;
          }
          return el;
        }),
      };
    case CONVERSATIONS_EMPLOYEE_BAN_UPDATE:
      return {
        items: state.items.map((el) => {
          if (el.employee.id === action.payload.id) {
            el.employee.isBlock = !el.employee.isBlock;
          }
          return el;
        }),
      };
    case CONVERSATIONS_EMPLOYEE_BAN:
      return {
        items: state.items.map((el) => {
          if (el.employee.id === action.payload.id) {
            el.employee.isCustomerBlocked = true;
          }
          return el;
        }),
      };
    case CONVERSATIONS_EMPLOYEE_UNBAN:
      return {
        items: state.items.map((el) => {
          if (el.employee.id === action.payload.id) {
            el.employee.isCustomerBlocked = false;
          }
          return el;
        }),
      };
    case CONVERSATIONS_ITEM_ACCEPT:
    case CONVERSATIONS_ITEM_COMPLETE:
      return {
        items: state.items.map((conversation) => {
          if (conversation.id === action.payload.conversation_id) {
            if (!action.payload.isMyChanges) {
              conversation.is_seen = false;
            }

            conversation.items.forEach((item, index) => {
              if (item.id === action.payload.type_id) {
                item[action.payload.status_name] = action.payload.status;
              }

              // remove item if deal is completed by both sides
              if (item[STATUS_PERSON.OWNER_STATUS] === DEAL_STATUS.COMPLETED && item[STATUS_PERSON.CLIENT_STATUS] === DEAL_STATUS.COMPLETED) {
                conversation.items.splice(index, 1)
              }
            });
          }
          return conversation;
        }),
      };

    case CONVERSATIONS_ITEM_REJECT:
      return {
        items: state.items.map((conversation) => {
          if (conversation.id === action.payload.conversation_id) {
            if (!action.payload.isMyChanges) {
              conversation.is_seen = false;
            }

            conversation.items = conversation.items.filter((item) => item.id !== action.payload.type_id);
          }
          return conversation;
        }),
      };

    case CONVERSATIONS_ITEM_SEEN:
      return {
        items: state.items.map((el) => {
          if (el.id === action.payload.conversation_id) {
            el.is_seen = true;
          }
          return el;
        }),
      };

    case CONVERSATIONS_ITEM_NOT_SEEN:
      return {
        items: state.items.map((el) => {
          if (el.id === action.payload.conversation_id) {
            el.is_seen = false;
          }
          return el;
        }),
      };
    default:
      return { ...state };
  }
}
